import React, { useEffect } from "react";
import { useNoIndex } from "@/lib/usePageSeo";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallbackPage() {
  useNoIndex();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = React.useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/admin");
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        const res = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(res.data.user);
        // clean hash
        window.history.replaceState({}, document.title, "/admin/dashboard");
        navigate("/admin/dashboard", { state: { user: res.data.user } });
      } catch {
        navigate("/admin?error=1");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] grid place-items-center bg-[#0F0F0F]">
      <div className="text-center">
        <div className="w-12 h-12 rounded-full mx-auto border-4 border-[#FF6600] border-t-transparent animate-spin" />
        <p className="mt-6 text-[#A3A3A3] text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
